export const companyResourceType = "company_item" as const;

export const getCompaniesResourcePath = (userId: string) => {
  return `/users/${userId}/companies`;
};
